<template>
	<div class="patient-view response">
		<ProgressCard :patient="patient"></ProgressCard>
	</div>
</template>

<script>
import PatientView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
	name: 'patient-progress',
	extends: PatientView,
	computed: {
		...mapGetters(['getUserType'])
	}
}
</script>
